export const CURRENCY_SYMBOLS = {
    EUR: '€',
    USD: '$',
    GBP: '£',
    BRL: 'R$',
    INR: '₹',
    CAD: 'CA$',
    AUD: 'AU$'
} as const;

export const FREQUENCIES = {
    YEARLY: 'yearly',
    MONTHLY: 'monthly'
} as const;
